module.exports = __webpack_public_path__ + "img/project-1.e80db17d.jpg";